<template>
  <div class="task-rail">

    <!-- Write with AI: suggestions next to the field; using one opens the field for editing -->
    <section v-if="aiField" class="v2-field task-ai" data-qid="task-ai-panel">
      <header class="v2-field__head">
        <h4><font-awesome-icon icon="sparkles" class="mr-2"/>{{ aiField.title }}</h4>
        <span class="v2-field__icon" @click="closeAi" data-qid="task-ai-close"><font-awesome-icon icon="times"/></span>
      </header>
      <p class="task-ai__hint">{{ $t('tasks.v2.ai_hint') }}</p>
      <div v-if="ailoading" class="task-ai__loading">
        <font-awesome-icon icon="spinner" class="fa-spin mr-2"/>{{ $t('tasks.modal.please_wait_while_processing') }} ({{ timeLeft }}s)
      </div>
      <b-alert v-if="aiField.error" show variant="danger">{{ aiField.error }}</b-alert>
      <template v-if="!ailoading">
        <div v-for="(choice, index) in aiField.choices" :key="'ai-' + index" class="task-ai__choice">
          <div class="text-formatted">{{ choice.message.content }}</div>
          <div class="task-ai__buttons">
            <b-button size="sm"
                      variant="success"
                      @click="useSuggestion(choice.message.content)"
                      data-qid="task-ai-use"
            >{{ $t('tasks.v2.use_this_text') }}</b-button>
            <b-button size="sm" variant="secondary" @click="copy(choice.message.content)">{{ $t('tasks.v2.copy') }}</b-button>
          </div>
        </div>
        <span class="v2-link cursor-pointer" @click="suggestAgain"><font-awesome-icon icon="sparkles" class="mr-1"/>{{ $t('tasks.v2.suggest_again') }}</span>
      </template>
    </section>

    <!-- The task's history, opened from the panel header -->
    <EngagementTaskHistory v-else-if="history" @close="$emit('close-history')"/>

    <!-- The chat stays visible on every page -->
    <EngagementTaskChat v-else :client="client"/>
  </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import EngagementTaskChat from './EngagementTaskChat.vue';
import EngagementTaskHistory from './EngagementTaskHistory.vue';

// Right-hand rail of the task panel: the chat, the task's history, or the Write with AI suggestions for a field
export default {
  name: 'EngagementTaskRail',
  mixins: [assessmentSingleTaskProxy],
  components: {
    EngagementTaskChat,
    EngagementTaskHistory
  },
  props: {
    // Documentation collection view: no internal notes
    client: {
      type: Boolean,
      default: false
    },
    // Shows the task's history instead of the chat
    history: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    aiField() {
      if (this.client) {
        return null;
      }
      if (this.isControlDescriptionDrawerOpen) {
        return { field: 'control_description', editMode: 'editModeControlDescription', title: this.$t('tasks.modal.write_control_description'), choices: this.controlDescriptionAi, error: this.errorDescriptionDrawer, toggle: 'toggleControlDescriptionDrawer' };
      }
      if (this.isTestingDrawerOpen) {
        return { field: 'performed_text', editMode: 'editModePerformedTest', title: this.$t('tasks.modal.write_test_plan'), choices: this.testPlanAi, error: this.errorTestingDrawer, toggle: 'toggleTestingDrawer' };
      }
      return null;
    }
  },
  methods: {
    closeAi() {
      this[this.aiField.toggle]();
    },
    suggestAgain() {
      const toggle = this.aiField.toggle;
      this[toggle]();
      this.$nextTick(() => this[toggle]());
    },
    // The suggestion goes into the field in edit mode; the user saves it
    useSuggestion(text) {
      const field = this.aiField;
      this.taskForm[field.field] = text;
      this[field.editMode] = true;
      this[field.toggle]();
    },
    copy(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
        this.$toastr('success', this.$t('tasks.v2.copied'));
      }
    }
  }
};
</script>
